import React from 'react';

interface CMSIconProps {
  name: string;
  isActive?: boolean;
  width?: string;
  height?: string;
}

const CMSIcon: React.FC<CMSIconProps> = ({ 
  name, 
  isActive = false, 
  width = '25px', 
  height = '25px' 
}) => {
  return (
    <img 
      src={`/cms/${name}.svg`} 
      alt={name} 
      style={{ 
        width, 
        height,
        filter: isActive ? 'brightness(0) invert(1)' : 'none'
      }} 
    />
  );
};

export default CMSIcon;
